const Lang = {
  "global.lang": "English",
  "global.networkerror": "No Network, please try again later",
  "global.loading": "Loading...",

  "global.fa": "فارسی",
  "global.zh": "Chinese",
  "global.en": "English",
  "global.ja": "Japanese",

  cancel: "Cancel",
  confirm: "Confirm",

  BSV: "BSV",
  BTC: "BTC",
  LATEST: "Latest",

  "unit.set": "set",

  /**
   * 关于我们介绍
   */
  "about.us": "About Us",
  "mempool.about.p1":
    "Mempool was founded in November 2018, it is to provide users with BTC and BSV mining services Bitcoin mining pool, but also the country's leading BSV mining pool.",
  "mempool.about.p2":
    "With AsicBoost technology, it can greatly reduce energy consumption, improve mining efficiency, and create higher and more benefits for users. “Real-time monitoring of mining machine , automatic switching of currency, automatic mining of mine, and transparent revenues of user”,  Mempool believes that the Nakamoto vision described in the original Bitcoin white paper is dedicated to creating a safe and stable digital pool currency.",
  "mempool.about.p3":
    "Mempool supports the Web and the Android. We will open the IOS soon, for users can enjoy the efficient and transparent mining pool services anytime and anywhere.",
  "mempool.about.company": "About Boquan Network",
  "mempool.about.p4":
    "Boquan Network was founded in June 2016.We are a company dedicating to technological innovation, focusing on the Blockchain Field. We are committing to Internet R&D in the Blockchainand digital currency sectors.",
  "mempool.about.p5":
    "Boquan possess a global Top5 mining farm and rich product line, including BCH wallet, Blockchain browser, Cloud computing power, mining pool, mining farm.",
  "mempool.about.p6":
    "Our target is to create an ecological circular to use the Blockchain to change the world.",
  "nourpool.about.p1":
    "Nourpool is a next-generation BSV/BTC mining pool aiming to provide class-leading reliability, innovative service model and exceptional customer experience to miners.",
  "nourpool.about.p2":
    "Founded in October 2019 in Shenzhen by a team that consists of experienced bitcoin miners and ex-developers from Microsoft and Baidu, Nourpool sets from the beginning to fulfilll the the original Satoshi's Vision. More professional services for the BSV eco-system are to come in 2020.",
  "exatoshi.about.p1":
    "exatoshi was founded in November 2018, it is to provide users with BTC and BSV mining services Bitcoin mining pool, but also the country's leading BSV mining pool.",
  "exatoshi.about.p2":
    "With AsicBoost technology, it can greatly reduce energy consumption, improve mining efficiency, and create higher and more benefits for users. “Real-time monitoring of mining machine , automatic switching of currency, automatic mining of mine, and transparent revenues of user”,  exatoshi believes that the Nakamoto vision described in the original Bitcoin white paper is dedicated to creating a safe and stable digital pool currency.",
  "exatoshi.about.p3":
    "exatoshi supports the Web and the Android. We will open the IOS soon, for users can enjoy the efficient and transparent mining pool services anytime and anywhere.",
  /**
   * 关于我们介绍 --- end
   */

  "miner.china": "CHN",
  "miner.europe": "EU",
  "miner.usa": "US",
  "miner.example": "Miner setting example:",
  "miner.address": "Miner address",

  // login
  login: "Login",
  poolLogin: "Login with mempool",
  dotLogin: "Login",
  dotRegister: "注册打点钱包账户",
  register: "Register",
  forgetPassword: "Forget password",
  withdrawToWeb: "Withdraw to DotWallet",
  reset: "Reset",
  returnToLogin: "Login",
  //
  newPassword: "Password, 8-16 digits",
  rePassword: "Confirm password",
  next: "Next",
  enterCode: "Verification code",
  getCode: "Send",
  loginType: "Email or phone number",
  goLogin: "Login",
  forgetSuccess: "Password reset succeeded",
  NoMailTips:
    "If the verification code is not received, it may be added to the blacklist by the operator. Please contact customer service.",
  passwordPlaceholder: "8-16 digit password",
  phonePlaceholder: "Please enter mobile number or email address",
  registerSuccess: "Registration success",
  UserAgreement: "Mempool Terms of Service",
  PrivacyPolicy: "Privacy Policy",
  SignAgreement: "Click register to agree ",
  NoAccount: " ",
  HaveAccount: " ",
  NowLogin: "Login now",
  NowRegister: "Register now",
  LoginBannerTitle1: "Better Bitcoin",
  LoginBannerTitle2: "mining experience",
  LoginBannerTip: "More benefits, safe and stable",

  "meta.homeTitle": "Mempool矿池-全球收益领先的BSV/BTC/BCH的比特币矿池",
  "meta.homeDescription":
    "Mempool矿池全网收益第一，提供BSV/BTC/BCH矿池挖矿服务，实现您轻松挖矿，为您收益保障护航。",
  "meta.homeKeyword": "比特币矿池、BSV矿池",

  //资金管理
  "fund.accountAddressTipsBTC": "Use the primary account BTC address",
  "fund.accountAddressTips": "Use the primary account address",
  "fund.LastModifiedTime": "Last modified time	",
  "fund.Set": "Set",
  "fund.NoWithdraw": "Not automatic withdrawal",
  "fund.Daily": "Daily withdrawal",
  "fund.tipsLeft": "When the balance >=",
  "fund.tipsRight": ", the daily UTC+8 14:00 automatic withdrawal to the withdrawal address",
  "fund.tipsBTCLeft": "When the balance >=",
  "fund.tipsBTCRight": "BTC, the daily UTC+8 14:00 automatic withdrawal to the withdrawal address",
  "fund.tipsBSVLeft": "When the balance >=",
  "fund.tipsBSVRight": "BSV, the daily UTC+8 14:00 automatic withdrawal to the withdrawal address",
  "fund.Save": "Save",
  "fund.Cancel": "Cancel",
  "fund.BTCToBSV": "BTC to BSV",
  "fund.noExchange": "Not automatic exchange",
  "fund.dailyExchange": "Daily exchange",
  "fund.moneyExchange": "Exchange by amount",
  "fund.time": "time",
  "fund.day": "day",
  "fund.MinExchange": "The minimum exchange amount is 0.01 BTC",
  "fund.ExTime": "Execution time (UTC+8)",
  "fund.SubAccount": "Sub-account",
  "fund.Balance": "Balance",
  "fund.Address": "Address",
  "fund.Operation": "Operation",
  "fund.BTCButton": "Withdraw BTC",
  "fund.BSVButton": "Withdraw BSV",
  "fund.BTCTOBSV": "Exchange",
  "fund.Monthly_bill": "Monthly bill",
  "fund.WithdrawAddress": "Withdraw address setting",
  "fund.setWithdraw": "Automatic withdrawal setting",
  "fund.ExchangeSetting": "Exchange setting",
  "fund.Last24hours": "Last Day Earns",
  "fund.Cumulative": "Cumulative income",
  "fund.TreasuryCurrent": "Value of treasury",
  "fund.Detail": "Details",
  "fund.Exchange": "Each exchange",
  "fund.BTCtopTips":
    "Do not fill in an address or mobile number other than BTC to avoid withdrawal to the wrong address",
  "fund.BSVtopTips":
    "Do not fill in an address or mobile number other than BSV legacy to avoid withdrawal to the wrong address",
  "fund.NoMailTips":
    "If the verification code is not received, it may be added to the blacklist by the operator. Please contact customer service.",
  "fund.NoAddress": "No address",
  "fund.BalanceTips": "The total withdrawal balance of all accounts",
  "fund.CumulativeTips": "The aggregate of the cumulative returns on all accounts",
  "fund.AddressTips1": "BTC/BSV withdrawal address",
  "fund.AddressTips2": "The newly created subaccounts will use this address by default",
  "fund.AddressTips3":
    "Each sub-account can set a different withdrawal address in [sub-account] - [Settings]",
  "fund.setWithdrawTips1": "BTC/BSV can be set up for automatic withdrawal",
  "fund.setWithdrawTips2": "The newly created subaccounts will use this setting by default",
  "fund.setWithdrawTips3":
    "Each sub-account can set different automatic withdrawal methods in [sub-account] - [Settings]",
  "fund.ExchangeSettingTips1": "It is currently supported to convert BTC into BSV",
  "fund.ExchangeSettingTips2": "The newly created subaccounts will use this setting by default",
  "fund.ExchangeSettingTips3":
    "Each sub-account can set different exchange methods in the [sub-account] - [Settings]",
  "fund.AutoWithdrawDayTip":
    "Exchange once a day, when the account BTC balance reaches the set amount, all BTC will automatically exchange to BSV",
  "fund.AutoWithdrawTimeTip":
    "Exchange on a per-time basis, when the account BTC balance reaches the set amount, all BTC will automatically exchange to BSV",
  "fund.Current": "Current",
  "fund.SameAccount": "Consistent with the primary account",
  "fund.dayChange": "Daily exchange",
  "fund.Mining": "Mining",
  "fund.MonitorAlarm": "Monitoring Setting",
  "fund.Watcher": "Watcher",
  "fund.none": "No Data",
  "fund.MonitorOpen": "Monitoring is turned on",
  "fund.MonitorClose": "Monitoring closed",
  "fund.moreHeigher": " more",
  "fund.better": " better, ",

  //共享费率
  "treasury.HandleFee": "Block Reward - Fees",
  "treasury.Deposit": "Deposit",
  "treasury.Withdrawal": "Withdraw",
  "treasury.PaymentFPPS": "Payment - FPPS",
  "treasury.BlockReward": "Block reward",
  "treasury.ColdWallet": "Cold wallet transfer out",
  "treasury.HotWallet": "Hot wallet into",
  "treasury.FundsFallback": "Funds fallback",
  "treasury.PayingFPPS": "Paying - FPPS",
  "treasury.PaymentBTC": "Payment-BTC Hashrate",
  "treasury.LockReward": "Lock reward",
  "treasury.ToBeConfirm": "Waiting for confirmation",
  "treasury.Refuse": "Refuse",
  "treasury.Confirm": "Confirmed",

  "treasury.Processing": "Processing",
  "treasury.Paid": "Paid",
  "treasury.PerHour": "Per hour",
  "treasury.PerMinute": "Per minute",
  "treasury.PerDay": "Per day",
  "treasury.ExchangeEchart": "BSV Exchange rate chart",
  "treasury.ChangePoolRecord": "Treasury changes",
  "treasury.ChangePoolRecordTip": "Records of miners paid and block rewards received",
  "treasury.RecordList": "Deposit and withdrawal history",
  "treasury.All": "All",
  "treasury.ChangeType": "Type",
  "treasury.Time": "Time",
  "treasury.Amount": "Amount",
  "treasury.BlockInfo": "Info",
  "treasury.Height": "Height",
  "treasury.Conf": "CONF",
  "treasury.DepositBSV": "Deposit BSV",
  "treasury.WithdrawalBSV": "Withdraw BSV",
  "treasury.Record": "My History",
  "treasury.DepositHistroy": "Deposit",
  "treasury.WithdrawHistroy": "Withdraw",
  "treasury.Status": "Status",
  "treasury.TXID": "TXID",
  "treasury.More": "All",
  "treasury.Mine": "Mine",
  "treasury.Investment income": "Investment income",
  "treasury.Proportion": "Proportion",
  "treasury.Lock BSV": "Lock BSV",
  "treasury.Tips": "New block must be transferred to the account after 100 confirmations.",
  "treasury.EarnTips": "Lock BSV included",
  "treasury.Exchangerate": "Exchange rate chart",
  "treasury.Progress": "Progress",
  "treasury.address": "Address",
  "treasury.Present Value": "Present Value",
  "treasury.Current Treasury": "Current Treasury",

  "treasury.MyBalance": "Snapshot of my balance",
  "treasury.MyBalanceTip": "Balance = Deposit + Unlocked - Paid FPPS - Withdrawal",
  "treasury.PoolBalance": "Snapshot of Treasury balance",
  "treasury.Blocks": "Block statistics",
  "treasury.BSVBlocks": "BSV blocks",
  "treasury.PersonalRecord": "My funds changes",
  "treasury.PoolRecord": "Treasury changes",
  "treasury.percent": "Withdrawal precent ",
  "treasury.percentAmount": "Estimated withdrawal",
  "treasury.sevenDay": "7 days",
  "treasury.mounth": "30 days",
  "treasury.3mounth": "90 days",
  "treasury.6mounth": "180 days",
  "treasury.all": "all",

  fees: "Electricity fee",
  machineName: "Type",
  power: "Hashrate",
  consumption: "Power",
  "Unit power consumption": "Unit power",
  "Daily output": "Rev.24H",
  "Daily electricity fee": "Energy",
  "Electricity cost ratio": "Electric Ratio",
  "Net profit/T/day": "Net profit /T/ day",
  "payback period": "Payoff period",
  "login.miner": "Select miner ",
  "login.input": "Enter price",
  "login.payoff": "day payoff",
  "login.rank": "Ranking",
  "login.update": "Data update at",
  "login.dayEarn": "Daily earnings",
  "login.okex":
    "The currency price is taken from the daily okex exchange price at 8:00 (UTC+8) AM.",
  "login.totalPower": "Miner Power",
  "login.dailyEarn": "Daily earnings PPS/T",

  "login.appText1": "View multiple account mining details,",
  "login.appText2": "manual withdrawal operation, miner view, ",
  "login.appText3": "sub-account Settings,",
  "login.appText4": "watcher account view ",
  "login.IOS": "iOS",
  "login.Android": "Android",

  "login.InfoTitle": "Know more about you",
  "login.Info1": "Support manual withdrawal",
  "login.Info1_text": "Manual withdrawal, high security and stable returns",
  "login.Info2": "Intelligent mining",
  "login.Info2_text": "Automatically choose higher earns mining，Support BTC, BSV switching",
  "login.Info3": "0 fee",
  "login.Info3_text":
    "Join the Treasure, fees can be as low as 0, more can share the benefits with mempool",
  "login.Info4": "First-class service",
  "login.Info4_text":
    "Professional operation and maintenance team, 7*24 hours non-stop service, ensure stable operation, revenue does not drop",

  "login.FAQ": "FAQ",
  "login.Q1": "How to withdraw manually?",
  "login.A1_1": "On the earns page, click the withdrawal button to initiate a manual withdrawal.",
  "login.A1_2":
    "Once the manual withdrawal is submitted successfully, a transfer will be initiated for you as soon as possible.",
  "login.Q2": "What is the automatic withdrawal threshold?",
  "login.A2_1": "BTC automatic withdrawal threshold is 0.01 BTC",
  "login.A2_2": "BSV automatic withdrawal threshold is 0.001 BSV",
  "login.A2_3": "Both BTC and BSV support custom deductibles",
  "login.Q3": "Why does the mining earns change?",
  "login.A3":
    "Bitcoin's difficulty in the whole network will change slightly every 2016 blocks. It is normal for the miners to keep a slight increase or decrease in the case of maintaining the original hashrate.",
  "login.Q4": "Why haven’t received the mining earns yet?",
  "login.A4":
    "Mining earns is paid once a day. Mempool will pay the mining earns from the previous settlement date (08:00 am to 08:00 am on the day of Beijing time) from 08:00 to 12:00 Beijing time. You can check the earns page.",

  // Heard
  "Header.dropdown.set": "Account settings",
  "Header.dropdown.exit": "Logout",
  "Header.Dashboard": "Dashboard",
  "Header.ShareFees": "Treasury",
  "Header.AgentManagement": "Partner management",
  "Header.AgentCreate": "New Partner",
  "Header.Tools": "Tools",
  "Header.Report": "Report",
  "Header.Watcher": "Watcher",
  "Header.Money": "Fund",
  "Header.More": "More",

  // 账户设置
  "LoginLog.Title": "Login record",
  "LoginLog.TitleTip":
    "Only the last 5 login records are displayed. For more records, please contact customer service",
  "LoginLog.TableTime": "Time",
  "LoginLog.TableCity": "City",
  "LoginLog.TableIP": "IP",
  "LoginLog.Security": "Security",
  "LoginLog.Password": "Password",
  "LoginLog.GoogleTitle": "Google verification",
  "LoginLog.Open": "Open",
  "LoginLog.Closed": "Closed",
  "LoginLog.weChatQRCode": "QR Code",
  "LoginLog.weChat": "WeChat Official Accounts",
  "LoginLog.weChatTips":
    "Pay attention to the WeChat Official Accounts, bind your mempool account to get message notification in real time.",
  "loginLog.CodeTip":
    "when log in, withdraw and set payment address, you will have to enter a 6-digit verification code.",
  "LoginLog.OtherSetting": "Other Setting",
  "LoginLog.ChooseTime": "Select time zone",
  "LoginLog.ChangePassword": "Change Password",
  "LoginLog.OldPassword": "Old Password",
  "LoginLog.NewPassword": "New Password",
  "LoginLog.ConfirmNewPassword": "Confirm New Password",
  "LoginLog.On": "Turn on Google verification",
  "LoginLog.Off": "Turn off Google verification",
  "LoginLog.Section1": "1、Install the Goolge Authenticator to your phone（Apple、Android）",
  "LoginLog.Section2": '2、Open the Goolge Authenticator and click on "Add User" - "Scan QR Code"',
  "LoginLog.Section3":
    "3、Scan the QR code on the screen or enter the key. Please backup the QR code and key",
  "LoginLog.Section4": "4、Enter the 6 digits displayed on the app",
  "LoginLog.key": "Key",
  "LoginLog.InputPlaceholder": "Please enter google verification code",
  "LoginLog.CloseTip":
    "Close Google verification will increase your account risk and is not good for your account property.",
  "LoginLog.SuccessTip":
    "You need to enter the 6-digit verification code when logging in, withdrawing, and setting the payment address",
  "LoginLog.SuccessText": "Binding success",
  "LoginLog.CloseTitle": "Google verification Closed",
  "LoginLog.OpenAgain": "You can turn on Google verification code again at any time",

  // footer
  "Footer.Products": "Products",
  "Footer.Pool": "Mempool",
  "Footer.Lastpurse": "Lastpurse",
  "Footer.Help": "Help",
  "footer.MiningSet": "Mining allocation",
  "Footer.Notice": "Notice",
  "Footer.Guide": "Guide",
  "Footer.Feedback": "Feedback",
  "Footer.Aboutus": "About us",
  "Footer.Cooperation": "Cooperation",
  "Footer.CustomerServices": "Customer Services",
  "Footer.Links": "Contant",
  "Footer.AddWeChat": "Add WeChat Customer Services",
  "Footer.copy": "Copy",
  "Footer.QQGroup": "QQ Group",
  "Footer.Android": "Android version",
  "Footer.Link": "Link",
  "Footer.Blockchain": "Blockchain.cn",
  "Footer.blockchair": "Blockchair",
  "Footer.recordNumber": " ",

  //IndexPage
  "SubTab.Earning": "Earns",
  "SubTab.Withdraw": "Withdraw",
  "SubTab.Changetab": "Exchanges",
  "SubTab.Switch": "Intelligent switch",
  "SubTab.BSV2BTC": "BSV to BTC",
  "IndexPage.Redeem": "Redeem to BTC",
  "IndexPage.history": "history",
  "SubTab.ExportTable": "Export",
  "Notice.More": "More",
  "IndexPage.totalHashrates": "Total Hashrates",
  "IndexPage.totalHashratesTips": "Summary data for all sub-accounts hashrates",
  "IndexPage.SubHashratesTips": "Summary data of current sub-accounts hashrates",
  "IndexPage.realTime": "Real-time",
  "IndexPage.hour24": "Today",
  "IndexPage.totalMiners": "Total Miners",
  "IndexPage.totalMinersTips1": "Summary data for all sub-accounts miners",
  "IndexPage.SubMinersTips1": "Summary data of current sub-accounts miners",
  "IndexPage.totalMinersTips2": "Normal:smooth running miner",
  "IndexPage.totalMinersTips3":
    "Low speed:The real-time hashrate of a single miner is 5 times lower than the rated hashrater or 80% of the 24-hour hashrate.",
  "IndexPage.totalMinersTips4": "Offline: miner did not submit new shares for 30 minutes",
  "IndexPage.online": "Normal",
  "IndexPage.onlineTip": "Online = Normal + Low",
  "IndexPage.low": "Low",
  "IndexPage.offline": "Offline",
  "IndexPage.Last24hours": "Last Day Earns",
  "IndexPage.BTC": "BTC",
  "IndexPage.BSV": "BSV",
  "IndexPage.Last24hoursTips":
    "Last day earns were between UTC 0:00-24:00(UTC+8 from 8:00 to 8:00 today)",
  "IndexPage.todayEstimate": "Today Estimate",
  "IndexPage.todayEstimateTip":
    "The expected gains today are affected by the operation of the miners and the network difficulty. ",
  "IndexPage.list": "Account list",
  "IndexPage.addAccount": "New Sub-account",
  "IndexPage.NewSubAccount": "New Sub-account",
  "IndexPage.accountName": "Sub-account",
  "IndexPage.chooseCoin": "Initial mining currency : ",
  "IndexPage.Earning": "Earnings estimate (1P*24h)",
  "IndexPage.Higher": "Higher",
  "IndexPage.Submit": "Submit",
  "IndexPage.Cancel": "Cancel",
  "IndexPage.Account": "Account",
  "IndexPage.MinersOnOff": "Miners(OK/Low/Off)",
  "IndexPage.RealTime": "Real-time",
  "IndexPage.RealTimeTips": "The last 15 minutes of average hashrate",
  "IndexPage.24hour": "24-hour",
  "IndexPage.24hourTips": "The last 24 hours of average hashrate",
  "IndexPage.dailyPower": "Daily",
  "IndexPage.dailyPowerTips": "The average hashrates of the day",
  "IndexPage.CoinType": "Currency",
  "IndexPage.change": "Intelligent switch",
  "IndexPage.On": "On",
  "IndexPage.Off": "Off",
  "IndexPage.changeTips": "Selected earns currency",
  "IndexPage.coinEarn":
    "The selected revenue currency, the mining pool will use smart switching to bring more earns to users",
  "IndexPage.Balance": "Balance",
  "IndexPage.Detail": "Detail",
  "IndexPage.chartList": "Charts",
  "IndexCharts.24hour": "24 Hours",
  "IndexCharts.7day": "7 days",
  "IndexCharts.mounth": "1 month",
  "IndexCharts.3mounth": "3 month",
  "IndexCharts.6mounth": "6 month",
  "IndexCharts.year": "1 year",
  "IndexCharts.all": "all",
  "IndexCharts.PerHour": "Per hour",
  "IndexCharts.PerDay": "Per day",
  "IndexCharts.power": "Hashrate Statistics",
  "IndexCharts.miner": "Miners Statistics",
  "IndexCharts.income": "Incomes Statistics",
  "IndexCharts.Hashrate": "Unstable hashrate?",
  "IndexPage.Optional": "Optional",
  "IndexPage.miner": "Miner",
  "IndexPage.totalMiner": "Miners Statistics",
  "IndexPage.totalEarn": "Earns",
  "IndexPage.setTriggerValue": "Trigger value",
  "IndexPage.IncomeHeigher": "Yield difference when switching",
  "IndexPage.longTime": "Duration",
  "IndexPage.switchDeriction": "Direction",
  "IndexPage.Ongoing": "Ongoing",
  "IndexPage.mainEarnTip": "Summary data for all sub-accounts miners",
  "IndexPage.Estimate": "Estimate",
  "IndexPage.Repayment Record": "Joint mining",
  "IndexPage.ChargeData Record": "",
  "IndexPage.Update": "Upate Date",
  "IndexPage.DailyBack": "Daily earns",
  "IndexPage.Accumulated Repayment": "Total earns",
  "IndexPage.Minus digital currency": "Digital currency deduction",
  "IndexPage.Price per day": "Price",
  "IndexPage.PriceInfo": "OKEX exchange daily trading price at 8am (UTC+8)",
  "IndexPage.chargeInfo": "The real-time price of the exchange when the fee is deducted",
  "IndexPage.standard": "Standard",
  "IndexPage.smart": "Intelligent",
  "IndexPage.management": "Management",
  "IndexPage.hidden": "Hidden",
  "IndexPage.show": "Show",

  // CustomerServices
  "CustomerServices.Customer_Services": "Customer Services",
  "CustomerServices.Contact_Us": "Contact",
  "CustomerServices.Que": "Que",
  "CustomerServices.XiaoMing": "XiaoMing",
  "CustomerServices.Xing": "XiaoXing",
  "CustomerServices.tel": "Tel：",
  "CustomerServices.Email": "Email：",
  "CustomerServices.Online_Time": "Online Time: From 10:00 AM to 10:00 PM on each Weekday",
  "CustomerServices.Email_us_or_Message":
    "Email us or Message us if you have problems on weekend,We will reply as soon as possible.Thank you! ",
  "CustomerServices.Follow_Us": "Follow Us",
  "CustomerServices.QQ": "QQ Official Group:",
  "CustomerServices.wx": "follow WeChat public accounts ",

  // SubSettingObserver
  "SubSettingObserver.WatcherSetting": "Watcher setting",
  "SubSettingObserver.WatcherAccount": "Watcher account",
  "SubSettingObserver.WatcherPlaceholder":
    "Please enter the full watcher primary account name to be added",
  "SubSettingObserver.AddedAccount": "Added account",
  "SubSettingObserver.ShareLink": "Shared link",
  "SubSettingObserver.WatcherTipsLeft": "Watcher can view the data of the sub-account",
  "SubSettingObserver.WatcherTipsRight":
    "through the above link, but cannot operate or modify your sub-account.",
  "SubSettingObserver.Set": "Set",
  "SubSettingObserver.AuthorizedAccount": "Authorized account",
  "SubSettingObserver.Close": "Close",
  "SubSettingObserver.None": "None",
  "SubSettingObserver.DeleteText": "Make sure to delete the authorized account ",
  "SubSettingObserver.CopySuccess": "Successful copy",
  "SubSettingObserver.ObserverLink": "Copy observer link",
  "SubSettingObserver.Ok": "Ok",

  "NoData.Text": "No Data",

  Back: "Back",
  Home: "Home",
  //IndexPage
  "IndexPage.FrozenMoney": "Locked",
  "IndexPage.FrozenTips1": "The proceeds from FPPLNS will be temporarily frozen ",
  "IndexPage.FrozenTips2": "and will need to be received after 100 confirmations.",
  "IndexPage.Repayment": "Joint mining amount",

  "IndexPage.earning.MiningDate": "Mine date",
  "IndexPage.earning.MiningDateTips1": "The bill generation date daily 8:30 (UTC+8)",
  "IndexPage.earning.MiningDateTips2": "Mining date is UTC time",
  "IndexPage.earning.Hashrate": "Hashrate",
  "IndexPage.earning.HashrateTips": "Average hashrate of mining date",
  "IndexPage.earning.settleWay": "Payment Structure",
  "IndexPage.earning.Lucky": "Lucky",
  "IndexPage.earning.LuckyTips": "The actual number of blocks / theoretical number of blocks",
  "IndexPage.earning.FrozenTip":
    "More earnings must wait until 100 confirmations before they can arrive.",
  "IndexPage.earning.FPPS": "FPPS additional revenue included:",

  "IndexPage.withdraw": "Withdraw",
  "IndexPage.withdraw.Time": "Time",
  "IndexPage.withdraw.Fee": "Fees",
  "IndexPage.withdraw.Address": "withdrawal address",
  "IndexPage.withdraw.Status": "Status",
  "IndexPage.withdraw.AccountId": "TXID",
  "IndexPage.withdraw.Paid": "Paid",
  "IndexPage.withdraw.NoPassed": "Refuse to pay",
  "IndexPage.withdraw.ToBeProcess": "To be processed",
  "IndexPage.withdraw.Processing": "Processing",

  "IndexPage.exchange.changeTime": "Currency Time",
  "IndexPage.exchange.Exchanged": "Exchanged",
  "IndexPage.exchange.InExchange": "In exchange",
  "IndexPage.exchange.NoChange": "Exchange failure",

  "IndexPage.Miner.ExportMiner": "Export miner information",
  "IndexPage.Miner.Miners": "Miners",
  "IndexPage.Miner.online": "Online",
  "IndexPage.Miner.RejectRate": "Reject Rate",

  "IndexPage.Miner.All": "All",
  "IndexPage.Miner.Online": "Online",
  "IndexPage.Miner.Low": "Low",
  "IndexPage.Miner.Offline": "Offline",

  "IndexPage.Miner.LastShare": "Last Share",
  "IndexPage.Miner.DefaultGroup": "Default group",
  "IndexPage.Miner.AddGroup": "Add group",
  "IndexPage.Miner.GroupName": "Group name",
  "IndexPage.Miner.EditGroupName": "Edit group",
  "IndexPage.Miner.PlaceholderGroup": "Enter group name",
  "IndexPage.Miner.LowMiner":
    "Low-miner,:the hash of a single miner is less than 80% of the hashrate for 5 consecutive times.",
  "IndexPage.Miner.Hashrate": "Single miner rated hashrate",
  "IndexPage.Miner.HashrateTips": "Please input rated hashrate",
  "IndexPage.Miner.DelGroupTips1": "After deleting the group ",
  "IndexPage.Miner.DelGroupTips2": "  , miners will be assigned to the default group.",
  "IndexPage.Miner.Continue": "Continue",
  "IndexPage.Miner.InputMinerName": "Enter miner name",
  "IndexPage.Miner.MoveTo": "Move to",
  "IndexPage.Miner.RunTime": "Statistical running time",
  "IndexPage.Miner.Time": "Time",
  "IndexPage.Miner.Electricity": "Statistical electricity bill",
  "IndexPage.Miner.ChangeGroup": "Move miners",
  "IndexPage.Miner.clear": "Clear offline miners",
  "IndexPage.Miner.clearText": "Are you sure you want to clear the offline miners?",
  "IndexPage.Miner.moveToGroup": "Move miners to",

  "IndexPage.Exchange": "Easy exchange",
  "IndexPage.ToPlaceholder": "Enter the number of BTCs to be exchanged",
  "IndexPage.Ava": "Available",
  "IndexPage.MinExchange": ", The minimum exchange amount is 0.01 BTC",
  "IndexPage.ExpectdExchange": "Expected exchangeable",
  "IndexPage.ExchangeTip1": "charges ",
  "IndexPage.ExchangeTip2":
    " exchange fee, The actual amount of exchange should be based on the transaction price.",
  "IndexPage.CurrentExchangeRate": "Current exchange rate",
  "IndexPage.ExchangeAll": "Exchange all",

  "IndexPage.BTCButton": "Withdraw BTC",
  "IndexPage.BSVButton": "Withdraw BSV",
  "IndexPage.LTCButton": "Withdraw LTC",
  "IndexPage.DOGEButton": "Withdraw DOGE",
  "IndexPage.fee": "Fee",
  "IndexPage.feeTips1": "The estimated cost of a single transaction is",
  "IndexPage.widthDrawTips": "Please enter the withdrawal amount",
  "IndexPage.feeTips2": ",Please refer to the time of payment",
  "IndexPage.TransferInfo": "Confirm withdrawal information",
  "IndexPage.Amount": "Amount",
  "IndexPage.AmountAll": "Withdraw Amount",
  "IndexPage.widthDrawAll": "Withdraw All",
  "IndexPage.Address": "Address",
  "IndexPage.MoreSub": "Multi-sub-account withdrawal",
  "IndexPage.GoogleTitle": "Google verification",
  "IndexPage.InputPlaceholder": "Please enter google verification code",
  "IndexPage.WithdrawTips.title": "Description",
  "IndexPage.WithdrawTips.tips1":
    "For your financial security, the following situations may trigger a manual review:",
  "IndexPage.WithdrawTips.tips2": "1.First withdrawal;",
  "IndexPage.WithdrawTips.tips3": "2.Large withdrawals;",
  "IndexPage.WithdrawTips.tips4": "3.Change the withdrawal address;",
  "IndexPage.WithdrawTips.tips5": "4.Other security issues.",
  "IndexPage.WithdrawTips.tips6":
    "If a manual review is triggered, we will complete the review within 2 hours, and the review time is from 10:00 to 19:00 (UTC+8) on weekdays.",
  "IndexPage.WithdrawTips.tips7":
    "Non-working time review time may be extended, for your financial security, please understand.",

  "IndexPage.MiningSet": "Mining Setting",
  "IndexPage.AiMining": "Intelligent mining",
  "IndexPage.IntelligentTips":
    "According to the income changes of BTC and BSV, choose high-yielding currency for mining",
  "IndexPage.TriggerValue": "Trigger value",
  "IndexPage.TriggerValueTip": "Trigger value required",
  "IndexPage.TriggerValueTips":
    " Switch when the price difference between BTC and BSV reaches the trigger value. The minimum value is 1%",
  "IndexPage.MinerEarn": "Earns",
  "IndexPage.Payout": "Revenue pattern",
  "IndexPage.AddressSet": "address Setting",
  "IndexPage.UseAccountAddr1": "Use the primary account",
  "IndexPage.UseAccountAddr2": "address",
  "IndexPage.withDrawTips1": "Do not fill in an address or mobile number other than ",
  "IndexPage.withDrawTips2": " to avoid withdrawal to the wrong address",
  "IndexPage.AlarmSetting": "Monitoring settings",
  "IndexPage.AlarmSwitch": "Monitoring switch",
  "IndexPage.HashRateAlarm": "Hashrate alarm",
  "IndexPage.ActiveMiners": "Miners alarm",
  "IndexPage.AlarmInterval": "Alarm interval",
  "IndexPage.AlarmEmail": "Contact eamil",
  "IndexPage.AlarmMobile": "Contact mobile number",
  "IndexPage.WatcherAccountList": "Watcher",
  "IndexPage.WatcherSetting": "Watcher setting",
  "IndexPage.WatcherAccount": "Watcher account",
  "IndexPage.WatcherPlaceholder": "Please enter the full watcher primary account name to be added",
  "IndexPage.AddedAccount": "Added account",
  "IndexPage.ShareLink": "Shared link",
  "IndexPage.WatcherTipsLeft":
    "Watcher can view the data of the sub-account through the above link,",
  "IndexPage.WatcherTipsRight": "but cannot operate or modify your sub-account.",
  "IndexPage.HashRateTooltip":
    "When hashrate is lower than the value, sending an alarm to the set contact",
  "IndexPage.ActiveMinersTooltip":
    "When active miners lower than the value,sending an alarm to the set contact",
  "IndexPage.AlarmIntervalTooltip":
    "Continuous alarm 3 times per day according to the set alarm interval",
  "IndexPage.EmailTooltip": "For receiving alarm emails, up to 3 can be set",
  "IndexPage.MobileTooltip": "For receiving alarm messages, up to 3 can be set",
  "IndexPage.HalfHour": "half hour",
  "IndexPage.AnHour": "an hour",
  "IndexPage.TwoHour": "2 hours",
  "IndexPage.UseSub": "Apply to all subaccounts",
  "IndexPage.valueTips": "Please enter a value from 1 to 100, accurate to 2 decimal places",
  "IndexPage.changeModeTip": "Revenue mode switch, effective at 8:00 (UTC + 8) the next day",
  "IndexPage.changeMinerTip1": "The revenue pattern will switch to ",
  "IndexPage.changeMinerTip2": " on the second day UTC + 8 8:00",
  "IndexPage.minute": "minute",
  "IndexPage.hour": "hour",
  "IndexPage.day": "day",

  "IndexPage.Replenishment": "Replenishment",
  "IndexPage.ReplenishmentTime": "Replenishment time",

  // 共享费率
  "IndexPage.DepositBSV": "Deposit BSV",
  "IndexPage.PayAddress": "Address",
  "IndexPage.NewAddress": "new address",
  "IndexPage.Text1": "Please transfer BSV to the above address",
  "IndexPage.Text2":
    "When the number of confirmations exceeds 3, the amount will be synchronized to the account.",
  "IndexPage.Text3": "Please wait 1 minute after transfer to check the result.",
  "WithDraw.low": "Low",
  "WithDraw.height": "Height",

  "IndexPage.noAccountTips1": "No sub-account created",
  "IndexPage.noAccountTips2":
    "Please click the New Sub Account button above to create a sub-account and start mining.",
  "IndexPage.steps1":
    "Access to local network and login the background system of miners, fill in the miner name and save the profile. The miners will be automatically added to mempool within one minute.",

  "mempool.indexPage.steps2":
    "Miner's name standard: sub-account+'.'+number, for example, your sub-account is mempool, then your miner name cloud be set as mempool.001, mempool.002.",
  "mempool.indexPage.addressRule1":
    "China mining URL：ss.mempool.com:25     ss.mempool.com:443     ss.mempool.com:1800",
  "mempool.indexPage.addressRule2":
    "International mining URL：ss-eu.mempool.com:25     ss-eu.mempool.com:443     ss-eu.mempool.com:1800",

  "nourpool.indexPage.steps2":
    "Miner's name standard: sub-account+'.'+number, for example, your sub-account is nourpool, then your miner name cloud be set as nourpool.001、nourpool.002.",
  "nourpool.indexPage.addressRule1.nourpool":
    "China mining URL：ss.nourpool.io:25     ss.nourpool.io:443     ss.nourpool.io:1800",
  "nourpool.indexPage.addressRule2.nourpool":
    "International mining URL：ss-eu.nourpool.io:25     ss-eu.nourpool.io:443     ss-eu.nourpool.io:1800",
  "exatoshi.indexPage.steps2":
    "Miner's name standard: sub-account+'.'+number, for example, your sub-account is exatoshi, then your miner name cloud be set as exatoshi.001、exatoshi.002.",
  "exatoshi.indexPage.addressRule1":
    "Mining URL：ss.exatoshi.com:2333      ss.exatoshi.com:3333      ss.exatoshi.com:4333",

  // Report
  Electricity: "Electric Charge",
  ElectricTips:
    "Configure power consumption and electricity price, to help you calculate the electricity cost",
  Miner: "Miner Running time",
  MinerTips: "Calculates the running time of all mines in a single sub-account",
  MonthBill: "Monthly bill",
  MonthTips:
    "On the 10th of each month, generate a detailed record for your sub-account for the previous month",
  Count: "Count",
  View: "View",
  SubAccount: "Sub-account",
  MonthList: "monthly bill list",
  Mail_receipt_billing_Settings: "Receive bill Settings",
  Mail_receipt_bill: "Receive bill",
  To_receive_your_email: "Email：",
  Delete: "Delete",
  Add: "Add",
  New_receiving_mailbox: "Add eamil",
  GetReport: "Generate reports",
  "Report.Mail.tableTip":
    "The monthly bill of the sub-account will be automatically generated and available for download at 10am (UTC+8) on the 10th of the following month. You can set mail to automatically receive bills.",
  "Report.Mail.Tips":
    "The monthly bill of the sub-account will be automatically sent to the set receiving mailbox at 10:00 am (UTC+8) on the 10th of the following month. Please check the receipt.",
  "Report.Mail.Tips1":
    "If no receiving email is set up, this contract will no longer automatically send monthly bills",
  "Report.Name": "Name",
  "Report.Time": "Date",
  "Report.Operation": "Operation",
  "Report.Download": "Download",

  "Report.Select": "Select",
  "Report.Elect": "Export Electricity bill",
  "Report.MinerName": "Miner name",
  "Report.RunTime": "Export Running time",
  "Report.more": "For more statistics, please",
  "Report.Elect.Price": "Electricity price",
  "Report.Elect.PowerWaste": "Power waste",
  "Report.Elect.Data": "Data",
  "Report.Elect.Other": "Other",
  "Report.Elect.RunTime": "Running time（hour）",
  "Report.Elect.OtherFee": "Other fee（￥）",
  "Report.Elect.Cost": "Total cost（￥）",
  "Report.Blank": "Blank",

  // Tool
  "Tool.AppTips":
    "View multiple account mining details,manual withdrawal operation, miner view, sub-account Settings, watcher account view",
  "Tool.SmartAgent": "Mempool smart agent",
  "Tool.SmartAgentInfo":
    "The stratum agent designed for large mining pools can greatly improve the communication efficiency between mines and mining pool.",
  "Tool.MiningCal": "Mini mining calculator",
  "Tool.MiningInfo": "A powerful and easy-to-use mining calculator,support BSV, BTC.",
  "Tool.link": "Count",
  "Tool.windows": "Windows 64",

  // Calculator
  "Cal.Hashrate": "Hashrate",
  "Cal.PPS24": "PPS 24h earns",
  "Cal.FPPS24": "FPPS 24h earns",
  "Cal.About": "Folding legal currency about",
  "Cal.Tips":
    "* Enter the effective power on the top and the theoretical gain on the bottom, enter theoretical income on the bottom and the effective power on the top.",
  "Cal.More": "More",
  "Cal.Close": "Close",
  "Cal.Legal": "Legal currency",
  "Cal.Price": "Currency price",
  "Cal.Diff": "Difficulty",
  "Cal.EarnPPS": "Earnings ratio (PPS)",
  "Cal.EarnFPPS": "Earnings ratio (FPPS)",

  // Agent
  "Agent.TodayIncome": "Today's income",
  "Agent.Cumulative": "Cumulative income",
  "Agent.Text": "Included in the Returns - Withdraw Amount",
  "Agent.Accounts": "Accounts",
  "Agent.Types": "Types",
  "Agent.EarnedGains": "Earned gains",
  "Agent.Gains": "Expected commission",
  "Agent.Remarks": "Remarks",
  "Agent.Agent": "Agent",
  "Agent.Miner": "Miner",
  "Agent.Edit": "Edit",
  "Agent.EditAccount": "Edit Account",
  "Agent.Income": "Theoretical income",
  "Agent.Create": "New Partner",
  "Agent.BTCFee": "BTC handling rate",
  "Agent.BSVFee": "BSV handling rate",
  "Agent.LTCFee": "LTC handling rate",
  "Agent.DOGEFee": "DOGE handling rate",
  "Agent.Add": "Create",
  "Agent.Success": "Account created successfully!",
  "Agent.New": "New",

  // Excel
  "Excel.amount": "Amount",
  "Excel.withDraw.Way": "withdrawal methods",
  "Excel.withDraw.Auto": "Auto",
  "Excel.withDraw.Manual": "Manual",
  "Excel.date": "Date",
  "Excel.BTCEarn": "Earns-BTC",
  "Excel.BTCOther": "Additional Earns-BTC",
  "Excel.BSVEarn": "Earns-BSV",
  "Excel.BSVOther": "Additional Earns-BSV",
  "Excel.BTCAmount": "BTC-amount",
  "Excel.changeTime": "Time",
  "Excel.cahnegRate": "BTC/BSV",
  "Excel.changeBSV": "TX BSV",
  "Excel.minerTitle": "Miners Report",
  "Excel.electricty": "Electricity bill statistics",
  "Excel.runTime": "Miners online time statistics",
  "Excel.getReport": "Please generate a report first",
  "Excel.report": "Export Excel",
  "Excel.feeBSV": "Fee(BSV)",
  "Excel.BTCTimeRange": "BTC-accounting time",
  "Excel.BSVTimeRange": "BSV-accounting time",

  // 活动字段
  ZeroRate: "Zero rate",
  "Affix.title1": "0 Rate BSV",
  "Affix.title2": "3.16～4.14",

  // v3.6
  "Loan.repayment": "Loan repayment",
  "Loan.self electricity": "Self-paid electricity",
  "Loan.electricity": "Pay electricity",
  "Loan.freight": "Freight",
  "Loan.maintenance": "Maintenance fees",
  "Loan.shelf": "Shelf fees",
  "Loan.off shelf": "Off shelf fees",
  "Loan.purchase": "Purchase of spare parts",
  "Loan.other": "Other",

  // v3.8
  upTitle: "Account system upgrade",
  upText1: "The mempool can log in with the DotWallet",
  upText2:
    "The current contract account has been automatically upgraded for you. Use this account to log in to the DotWallet.",
  upText3: "If your Dotwallet account is same with mempool acccount, please login with Dotwallet.",
  upText4:
    "Now you can select [Withdraw to DotWallet] in the address settings, no need to set the withdrawal address.",
  know: "Know it",

  // v3.8.1
  MSG_please_contact_customer_service:
    "Account login is not authorized, please contact customer service wechat",

  // v4.0.0
  contactLTC: "Need to contact customer service to start LTC mining",

  /**
   *
   * MSG请一律放后面
   */
  MSG_withdrawal_type_not_supported_in_current_currency:
    "This type of withdrawal address is not supported by the current currency",
  MSG_unsupported_withdraw_type:
    "This type of automatic withdrawal is not supported by the current currency",
  MSG_wrong_withdraw_type: "Incorrect auto-withdrawal type",
  MSG_input_username: "Please input username",
  MSG_input_password: "Please input password",
  MSG_user_not_exist: "User does not exist",
  MSG_login_fail: "Login failed, please try again",
  MSG_incorrect_input_phone_number_or_mailbox_format: "Account format error",
  MSG_username_or_password_incorrect: "Username or password incorrect",
  MSG_wrong_withdraw_address_format: "Wrong withdraw address format",
  MSG_withdraw_fee_expire: "The submission page has timed out and the latest fee has been reloaded",
  MSG_user_withdraw_address_not_set: "Account withdrawal address is not set",
  MSG_wrong_username_format: "Mobile phone number or email format is incorrect",
  MSG_wrong_password_format: "8-16 passwords contain letters, numbers, special characters",
  MSG_wrong_username: "Input mobile number or email",
  MSG_verify_pass: "Verification passed",
  MSG_exchange_apply_success: "Application submitted",

  "MSG_amount_below_the_minimum_limit_0.005": "The exchange amount must be greater than 0.005",
  MSG_user_failed_to_login_or_expired: "Login expired",
  MSG_login_out_seccess: "Logout success",
  MSG_input_verify_code: "Please input verify code",
  MSG_input_withdraw_address: "Please input withdraw address",
  MSG_edit_success: "Edit success",
  MSG_edit_fail: "Edit fail",
  MSG_input_old_password: "Input old password",
  MSG_input_new_password: "Input new password",
  MSG_input_new_password_confirm: "Input new password confirm",
  MSG_password_inconsistent: "Password inconsistent",
  MSG_wrong_withdraw_amount: "Wrong withdraw amount",
  MSG_amount_below_the_minimum_lit: "Amount below the minimum lit",
  MSG_withdraw_apply_success: "Withdraw request submitted",
  MSG_catch_error: "Catch error",
  MSG_withdraw_address_not_set: "Withdraw address not set",
  MSG_send_success: "Sent successfully",
  MSG_user_password_incorrect: "Wrong password",
  "MSG_amount_below_the_minimum_limit_1.5": "Withdraw amount must be greater than 1.5",
  "MSG_amount_below_the_minimum_limit_0.01": "Withdraw amount must be greater than 0.01",
  "MSG_amount_below_the_minimum_limit_0.001": "Withdraw amount must be greater than 0.001",
  MSG_user_not_exists: "User does not exsist",
  MSG_register_success: "Rigster success",
  MSG_add_success: "New success",
  MSG_edit_password_success: "Reset success",
  MSG_edit_password_faile: "Reset failed",
  MSG_edit_password_fail: "Reset failed",
  MSG_edit_password_failed: "Reset failed",
  MSG_set_mobile_success: "Set mobile success",
  MSG_set_email_success: "Set email success",
  MSG_user_mobile_already_exists: "User exists",
  MSG_pay_password_err: "Incorrect password!", //Incorrect password!
  MSG_not_have_token_utx: "lack token!",
  MSG_trans_utx_faile: "Failed to transfer!", //Failed to transfer!
  MSG_not_have_token_addr: "Failed to get address!", //Failed to get address.
  // new
  MSG_please_input_phone_number_or_email: "Email or Phone",
  MSG_user_email_already_exists: "Email already exists.",
  MSG_token_is_ok: "Token is available. ",
  MSG_save_code_fail: "Failed to sent.",
  MSG_user_email_not_exists: "Email not exists.",
  MSG_user_mobile_not_exists: "Phone not exists.",
  MSG_login_out_sucess: "Already login out.",
  MSG_user_email_have: "Email have linked.",
  MSG_user_mobile_have: "Phone have linked.",
  MSG_set_info_success: "Success!",
  MSG_set_userinfo_success: "User information updated.",
  MSG_please_input_username: "Username",
  MSG_need_public_key: "Public-key is null.",
  MSG_userMnemonic_already_backup: "Mnemonics has backed up.",
  MSG_pay_password_not_empty: "Payment password is null.",
  MSG_addr_type_is_only_BSV_BTC: "Only allow BSV or BTC",
  MSG_pay_amount_err: "Pay amount error!",
  MSG_pay_address_err: "Address error!",
  MSG_transfer_to_user_receive_faile: "Failed to transfered.",
  MSG_transfer_money_type_err: "Failed to received.",
  MSG_transfer_money_need_user_id: "Please enter ID.",
  MSG_pay_to_addr_user_id_err: "ID error!",
  MSG_not_pay_to_user_self: "Don’t transfer to yourself.",
  MSG_pay_password_empty: "Payment password is null.",
  MSG_user_money_not_enough: "Out of account balance!",
  MSG_token_is_empty: "code is null",
  MSG_code_is_err: "code is error",
  MSG_account_locked: "The account is locked. Please try again in 15 minutes.",
  MSG_account_locked_three: " Lock account after 3 errors",
  MSG_account_locked_two: "Lock account after 2 errors",
  MSG_account_locked_one: "Lock account after 3 errors",
  MSG_send_mobile_success: "Verification code has been sent to the mobile number",
  MSG_send_email_success: "Verification code has been sent to the email address",
  // 子账户创建提示
  MSG_user_name_type_incorrect:
    "Subaccount name should be 4 to 30 letters or numbers, and lowercase letters only at the beginning of",
  MSG_do_faile: "Creation failed, please try again",
  MSG_the_name_of_the_input_sub_account_already_exists: "Enter sub-account name already exists",
  MSG_user_is_have: "User already exists",
  // MSG_exchange_success: "Exchange success",
  MSG_send_fail: "Send failed",
  MSG_please_input_ga_code: "Enter google verification code",
  MSG_wait_few_seconds_generate: "Please wait a few seconds to generate an address",

  // 提现提示
  "MSG_amount_must_be_greater_than_1.5": "The amount of withdraw must be greater than 1.5",
  "MSG_amount_must_be_greater_than_0.01": "The amount of withdraw must be greater than 0.01",
  "MSG_amount_must_be_greater_than_0.0001": "The amount of withdraw must be greater than 0.0001",
  MSG_please_set_up_BTC_cash_address_first: "Please set the BTC withdrawal address first",
  MSG_please_set_up_BSV_cash_address_first: "Please set the BSV withdrawal address first",
  MSG_withdraw_success: "Withdrawal of application successfully",
  MSG_withdraw_fail: "Withdrawal of application failed",
  MSG_exchange_success: "Submitted successfully",
  MSG_exchange_fail: "Submission Failed",
  MSG_exchange_amount_must_be_greater_than_0: "The exchange amount is less than 0.01BTC",
  MSG_no_exchange_power: "Unopened permission",
  MSG_cash_amount_must_be_digits: "The withdrawa amount must be a number",
  MSG_cash_application_failed: "Withdrawa request failed",
  MSG_act_success: "Successful operation",
  MSG_unable_to_get_total_account_number: "Unable to get the total account number",
  MSG_amount_must_be_greater_than_0: "The amount of withdraw must be greater than 0.01",
  MSG_account_balance_is_insufficient: "Insufficient account balance",
  MSG_failure_to_application: "Failed to generate withdrawal request record",
  MSG_exchange_amount_not_enough: "The exchange amount is less than 0.01BTC",
  MSG_please_input_bsv_address: "Please input BSV address",
  MSG_please_input_btc_address: "Please input BTC address",
  MSG_please_set_address: "Please set withdrawal address first",
  "MSG_amount_must_be_greater_than_0.00000546":
    "The amount of withdraw must be greater than 0.00000546",
  MSG_input_the_correct_btc_fee_present: "BTC rate error",
  MSG_input_the_correct_bsv_fee_present: "BSV rate error",

  // 导出提示
  MSG_please_input_data_time: "Please enter the start and end times",
  MSG_please_input_data_start: "Please enter the start time",
  MSG_please_input_data_end: "Please enter the end time",
  MSG_please_input_electric_charge: "Please enter the electricity fee",
  MSG_please_input_power: "Please enter power",
  MSG_please_input_other: "Other fee format error",
  MSG_excel_fail: "Export Excel failed",
  MSG_please_input_mobile_or_email: "Input mobile number or email",
  "MSG_exchange_amount_must_be_greater_than_0.01":
    "The exchenge amount must be greater than 0.001 BTC",
  MSG_please_select_monitoring_mode: "Select a monitoring mode",
  MSG_set_up_at_most_three_emails: "Set up to three emails",
  MSG_incorrect_email_format: "Wrong eamil format",
  MSG_set_up_at_most_three_mibiles: "Set up to three mobile numbers",
  MSG_incorrect_mobile_format: "Wrong mobile format",
  MSG_please_input_hash_rate_warn_value: "Input a valid value",
  MSG_please_input_subuser_id: "Please enter subuser ID",

  //
  MSG_incorrect_password_format: "8-16 passwords contain letters, numbers, special characters",
  MSG_verify_code_incorrect: "Verification code error",
  MSG_name_size_less_than_50: "The name can be up to 50 characters long",
  MSG_bind_fail: "Binding failed",
  MSG_secret_expired: "Key expired",
  MSG_ga_code_incorrect: "Google verification code error",
  MSG_please_input_amount: "Please input amount",
  MSG_please_input_amount_btc: "Please input amount",
  MSG_please_input_amount_bsv: "Please input amount",
  MSG_balance_insufficient: "Insufficient balance",
  MSG_balance_insufficient_fee: "Account balance is insufficient to pay the  fee",
  MSG_email_format_incorrect: "Email format error",
  MSG_amount_must_be_greater_than_smallest_amount:
    "Withdraw amount must be greater than minimum limit amount",
  MSG_amount_must_be_greater_than_smallest_amount_btc:
    "Withdraw amount must be greater than minimum limit amount 0.001BTC",
  MSG_amount_must_be_greater_than_smallest_amount_bsv:
    "Withdraw amount must be greater than minimum limit amount 0.001BSV",
  MSG_fill: "Please fill in the required fields",
  MSG_you_can_only_change_it_once_two_hour:
    "Less than 2 hours since the last switch, please try again later",
  MSG_withdraw_amount_illegal: "Incorrect format，please re-enter",

  // 后端重构v3.4新增提示
  MSG_rated_power_err: "Single miner rated hashrate",
  MSG_you_can_only_change_it_once_an_hour: "Revenue mode can only be switched once per hour",
  MSG_input_fee_rate_error: "Incorrect format，please re-enter",
  MSG_amount_percent_err: "Enter a value greater than 0 and less than or equal to 100",
  MSG_add_fail: "Fail to add",
  MSG_data_type_err: "incorrect type",

  //v3.7.7
  MSG_hidden_sub: "Please keep at least one sub-account",
  MSG_please_input_is_hidden: "The parameter is missing",
  MSG_please_input_setHidden_subuser_id: "Please check the sub-account",

  // 旧版MSG
  MSG_no_user_id_modify: "Missing user ID to modify",
  MSG_user_phone_number_already_exists: "The  mobile number already exists",
  MSG_please_input_user_name: "Please enter a username",
  MSG_no_user_id_to_delete: "Missing user ID to delete",
  MSG_user_phone_number_not_exist: "User phone number does not exist",
  MSG_lack_of_user_id_to_opened: "Missing user ID to be activated",
  MSG_failure_to_deduct_money: "Deduction failed, there may be insufficient balance",
  MSG_mobile_not_be_empty: "Mobile cant be empty, please check",
  MSG_id_is_empty: "id is empty",
  MSG_no_user_id_to_modify: "Missing user ID to modify",
  MSG_no_content_to_modified: "Missing user ID to modify",
  MSG_incorrect_account_type: "Account type is incorrect",
  MSG_lack_of_withdrawals_id: "Missing withdrawal request ID",
  MSG_please_input_info: "Please enter the remark information such as the transaction number",
  MSG_please_input_pay_password: "Please enter the payment password",
  MSG_pay_password_is_incorrect: "Payment password is incorrect",
  MSG_failed_to_modify_audited:
    "The database modification failed. The information may not be pending",
  MSG_admin_are_not_logged: "Administrator not logged in",
  MSG_do_successfully: "Set successfully",
  MSG_please_enter_mobile: "Please enter the users mobile number",
  MSG_enter_user_permissions: "Please enter the user permission ID",
  MSG_please_input_user_password: "Please enter a user password",
  MSG_add_user_success: "Add user success",
  MSG_add_user_fail: "Add user failed",
  MSG_admin_not_logged: "Administrator not logged in",
  MSG_modify_user_success: "Modify user success",
  MSG_modify_user_fail: "Modify user failed",
  MSG_user_does_not_exist: "User information does not exist",
  MSG_delete_user_success: "Delete user successfully",
  MSG_delete_user_fail: "Delete user failed",
  MSG_lack_of_user_id: "Missing user ID",
  MSG_open_user_success: "Open user success",
  MSG_open_user_fail: "Failed to open user",
  MSG_input_the_correct_mobile: "Please enter the correct mobile",
  MSG_mobile_is_wrong: "The phone number format is incorrect, please check",
  MSG_subaccount_is_incorrect: "The sub-account id entered is incorrect",
  MSG_please_input_correct_settlement: "Please enter the correct billing method",
  MSG_input_id_is_wrong: "The input subordinate id is incorrect, please check",
  MSG_can_not_switch: "Cant switch",
  MSG_do_not_switch_to_current_mode: "Cannot switch to the current mode",
  MSG_you_can_only_change_it_once_a_day: "Can only be modified once a day",
  MSG_switch_error_please_try_again: "Switching error, please try again",
  MSG_input_at_least_one_modification_parameter: "Please enter at least one modification parameter",
  MSG_input_the_correct_proportion: "Please enter the correct draw ratio",
  MSG_get_sub_account_list: "Get a list of sub accounts",
  MSG_input_login_name: "Please enter your login name",
  MSG_sub_account_does_not_exist: "This sub-account does not exist, please check",
  MSG_failed_to_modify_sub_account: "Failed to modify sub-account information",
  MSG_the_number_of_sub_accounts_is_incorrect:
    "The number of sub-accounts is incorrect. Please check",
  MSG_verify_fail: "Verification failed",
  MSG_authentication_failed: "Authentication failed, please login",
  MSG_fail_please_check: "The query failed, please check",
  MSG_send_successfully: "Sent successfully",
  MSG_id_incorrect: "The input id is incorrect, please check",
  MSG_can_only_switch_to_pps: "Can only switch to PPS",
  MSG_user_no_login: "User not logged in",
  MSG_no_permission: "No create permission",
  MSG_The_settlement_method_can_only_be_FPPS_or_FPPLNS: "Settlement can only be FPPS or FPPLNS",
  MSG_The_settlement_method_can_only_be_FPPS: "Settlement can only be FPPS",
  MSG_The_settlement_method_can_only_be_PPS: "Settlement can only be PPS",
  MSG_delete_faile: "Deleting user failed",
  MSG_delete_sucess: "Delete user successfully",
  MSG_the_old_password_entered_is_empty: "The old password entered is empty, please check",
  MSG_the_new_password_entered_is_empty: "The new password entered is empty, please check",
  MSG_incorrectpasswordformat:
    "Password must be 8 to 16 digits, containing at least one letter, one number, one special character",
  MSG_the_number_of_sub_users_is_not_compliant:
    "The number of sub-users is not compliant, please check",
  MSG_please_input: "Please enter information",
  MSG_please_input_mobile_or_eamil: "Please enter your mobile number or email address",
  MSG_input_the_proportion: "Please enter the proportion",
  MSG_please_input_right_user_type: "Please enter the correct user type",
  MSG_input_the_correct_default_settlement_method: "Please enter the correct default settlement",
  MSG_please_input_user_id: "Please enter the user id",
  MSG_please_enter_verification_code: "Please enter verification code",
  MSG_addr_incorrect: "The address type to be modified is incorrect",
  MSG_can_not_get_mobile_or_email: "Unable to get phone number or emai",
  MSG_please_input_days: "Please enter the number of days to count",
  MSG_please_input_type: "Please enter the address to be modified",
  MSG_please_enter_addr: "Please enter the withdrawal address to be set",
  MSG_code_incorrect: "Incorrect verification code",
  MSG_send_verify_code_fail: "Send verification code failed",
  MSG_input_invite_code: "Pleaes input invitation code",
  MSG_invite_code_incorrect: "Invitation code error",
  MSG_invite_code_expired: "Invitation code has expired",
  MSG_user_name_length_incorrect: "Sub-account name should be between 4-30 digits in length",
  MSG_reset_password_fail: "MSG_reset_password_fail",
  MSG_reset_password_success: "Reset password successfully",
  MSG_rated_power_not_is_empty: "Rated hashrate is empty",
  MSG_input_the_correct_auto_switch_rate: "The trigger value should be between 1% and 100%",
  MSG_binding_user_inconsistent:
    "This WeChat is not bound to the mine pool account and cannot be unbound",
  MSG_bound_user: "This account has been bound with other WeChat ID, please unbind and try again",
};

export type Language = typeof Lang;
export default Lang;
